import {
  Box,
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  Text,
  useDisclosure,
} from '@chakra-ui/react'
import { userListContext } from 'BrokerTsLib/src/context'
import { UserGridItem, UserPagedQuery, UserRole } from 'BrokerTsLib/src/dtos'
import { useSearchUsers } from 'BrokerTsLib/src/hooks/useUser'
import { useEffect, useState } from 'react'
import { Add } from '../../icons'
import { ListItemAddedButton } from '../shared/ListItemActionButtons'
import {
  UserList,
  UserListEmailColumn,
  UserListNameColumn,
  UserListOrganizationColumn,
  UserListTypeColumn,
  UserListUserNameColumn,
} from '../users/UserList'
import { UserListFilter } from '../users/UserListFilter'

const pageSize = 15
export const AddFlexGroupUser = ({
  onAddUser,
  alreadyAdded,
}: {
  onAddUser: (item: UserGridItem) => void
  alreadyAdded: UserGridItem[]
}) => {
  const { isOpen, onOpen, onClose } = useDisclosure()
  const [filter, setFilter] = useState<UserPagedQuery>({
    showInvalid: true,
    pageIndex: 1,
    pageSize,
    showAllItems: true,
    roles: [UserRole.SpecialUser],
  })

  const { data, mutateAsync: getAll, isLoading } = useSearchUsers()

  useEffect(() => {
    if (isOpen) getAll(filter)
  }, [isOpen, filter, getAll])

  const possibleUsers =
    data?.data.items.filter(
      (x) => !alreadyAdded.some((y) => y.userId === x.userId),
    ) ?? []

  return (
    <Box>
      <Button size={'sm'} colorScheme="primary" onClick={() => onOpen()}>
        <Add /> Přidat uživatele do flexibilní skupiny
      </Button>
      <Modal size="6xl" isOpen={isOpen} onClose={onClose}>
        <ModalOverlay />

        <ModalContent>
          <ModalHeader>
            <Text>Přidat uživatele do flexibilní skupiny</Text>
            <ModalCloseButton />
          </ModalHeader>

          <ModalBody sx={{ pt: 0, pb: 6, gap: 4 }}>
            <userListContext.Provider
              value={{
                loading: isLoading,
                totalCount: data?.data.totalCount ?? 0,
                currentPage: 1,
                pageSize,
                filter,
                setCurrentPage: () => {},
                setPageSize: () => {},
                updateFilter: setFilter,
                reload: () => getAll(filter),
              }}
            >
              <Flex flexDir={'column'} gap={4}>
                <UserListFilter hideInactiveFilter />
                <UserList
                  users={possibleUsers}
                  withPaginator={true}
                  columnsDefinition={[
                    UserListNameColumn,
                    UserListOrganizationColumn,
                    UserListUserNameColumn,
                    UserListEmailColumn,
                    UserListTypeColumn,
                    {
                      key: 'addToFlexGroup',
                      name: '',
                      cellExpr: (item) => (
                        <ListItemAddedButton
                          sx={{ ml: 'auto' }}
                          onClick={() => onAddUser(item)}
                        />
                      ),
                    },
                  ]}
                />
              </Flex>
            </userListContext.Provider>
          </ModalBody>
        </ModalContent>
      </Modal>
    </Box>
  )
}
